import React, { useEffect, useState } from 'react';
import { ListPage } from '../ListPage';
import config from '../../config';
import * as API from '../../helpers/api';
import { useHistory } from 'react-router-dom';
import Loading from '../modules/loding';

export default function NewsList() {
	const [apiData, setApiData] = useState({});
	const [isBusy, setBusy] = useState(true);
	let history = useHistory();
	const pageTitle = 'Նորություն';

	const addNew = () => {
		history.push(`add`);
	};

	useEffect(() => {
		(async () => {
			let news = await API.get(config.api.news);
			setApiData(news);
			setBusy(false);
		})();
	}, [isBusy]);

	const columns = [
		{
			dataField: 'title.en',
			text: 'Title',
			filter: true,
			sort: true,
		},
		{
			dataField: 'title.ru',
			text: 'Заглавие',
			filter: true,
			sort: true,
		},
		{
			dataField: 'title.hy',
			text: 'Վերնագիր',
			filter: true,
			sort: true,
		},
		{
			dataField: 'date',
			text: 'Ամսաթիվ',
			// filter: true,
			// sort: true,
			formatDate: true,
		},
	];

	if (isBusy) return <Loading />;
	else
		return (
			<>
				<section className='content-header'>
					<div className='container-fluid'>
						<div className='row'>
							<div className='col-sm-12' align='center'>
								<h1>{`${pageTitle}ների ցուցակ`}</h1>
							</div>
						</div>
					</div>
				</section>
				<section className='content'>
					<div className='container-fluid'>
						<div className='row'>
							<div className='col-md-12'>
								<div className='card'>
									<div className='card-body'>
										<ListPage
											apiData={apiData}
											columns={columns}
											route={config.api.news}
											addNew={addNew}
											pageTitle={pageTitle}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
			</>
		);
}
